export default __webpack_public_path__ + "static/media/netoToMyob.8c24c877.png";